// Reduce page dynamic imports, extracted so they can be shared between
// the router and the REDUCEV3 layout.

import { createPreloadableLazyRoute } from '/shared/components/functional/lazyLoad';

type ReduceRouteProps = Record<string, never>;

const reduceAppRoutes = {
  ReduceComparison: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/comparison/ComparisonPage'),
  ),
  ReduceOnboarding: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/onboarding/OnboardingPage'),
  ),
  ReduceHotspots: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/hotspots/HotspotPage'),
  ),
  ReduceTargets: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/targets/TargetPage'),
  ),
  ReduceRequestInfo: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/requestinfo/RequestInfoPage'),
  ),
  ReduceInitiatives: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/initiatives/InitiativePage'),
  ),
  ReducePlan: createPreloadableLazyRoute<ReduceRouteProps>(
    () => import('/business/shared/components/pages/reduce/v3/subpages/plan/PlanPage'),
  ),
};

/**
 * Preload all reduce sub-page components through the same loaders used by the router.
 * Call this when the user enters any reduce page so subsequent route rendering
 * can use the resolved component without showing the Suspense fallback.
 */
export function preloadReducePages() {
  return Promise.all(Object.values(reduceAppRoutes).map((route) => route.preload()));
}

export default reduceAppRoutes;
